import { useState } from 'react';

import { Alert, Button, Dialog, Snackbar, Typography, DialogTitle, DialogActions, DialogContent } from '@mui/material';

import { isNativeApp } from '../utils/native-bridge';
import { usePwaUpdates } from '../hooks/use-pwa-updates';

export default function ReloadPrompt() {
  const updates = usePwaUpdates();
  const native = isNativeApp();
  const [confirm, setConfirm] = useState(false);
  const available = updates.ready || updates.moduleError;

  return <>
    {native && <Snackbar open={available && !updates.deferred && !confirm} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert severity="info" action={<>
        <Button color="inherit" size="small" onClick={() => setConfirm(true)}>Aggiorna</Button>
        <Button color="inherit" size="small" onClick={updates.defer}>Più tardi</Button>
      </>}>
        Aggiornamento pronto
      </Alert>
    </Snackbar>}
    <Dialog open={native ? confirm : available} fullWidth maxWidth="xs">
      <DialogTitle>{native ? 'Aggiornare adesso?' : 'Nuovo aggiornamento disponibile'}</DialogTitle>
      <DialogContent>
        <Typography>
          {native ? 'La pagina verrà ricaricata. Le modifiche non salvate andranno perse.' : 'Nuova versione disponibile, clicca su Aggiorna per procedere.'}
        </Typography>
        {updates.error && <Alert severity="error" sx={{ mt: 2 }}>Aggiornamento non riuscito. Riprova.</Alert>}
      </DialogContent>
      <DialogActions>
        {native && <Button disabled={updates.applying} onClick={() => { setConfirm(false); updates.defer(); }}>Più tardi</Button>}
        <Button disabled={updates.applying} onClick={updates.apply}>{updates.applying ? 'Aggiornamento…' : 'Aggiorna'}</Button>
      </DialogActions>
    </Dialog>
  </>;
}
